/** @jsx jsx */
import { jsx } from 'theme-ui'

const AttentiveScript = () => (
  <script src="https://cdn.attn.tv/makerwine/dtag.js"></script>
)

export default AttentiveScript
